import styled from 'styled-components';
import { Table, TableRow, TableRowProps, TableCell, Box, Button as MUIButton } from '@mui/material';
import { handleNodeColor } from 'utils';
import { SecondaryNodeColor } from 'types';

export const MUITable = styled(Table)`
  min-width: 336px;
  width: 100%;
  display: table;
  table-layout: auto;
  justify-self: start;
  align-self: start;
`;

MUITable.defaultProps = {
  size: 'small',
};

export const HeadRow = styled(TableRow)``;

export const HeadCell = styled(TableCell)`
  color: ${({ theme }) => theme.palette.grey[500]};

  &&& {
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    padding: ${({ theme }) => theme.spacing(1, 0.5)};
    font-size: 12px;
    white-space: nowrap;
    border: none;

    &:nth-of-type(2) {
      text-align: end;
      padding-right: 0;
    }
  }
`;

interface ITableRowProps extends TableRowProps {
  color?: SecondaryNodeColor;
}

export const BodyRow = styled(TableRow)`
  & .MuiTableCell-root {
    color: ${({ color, theme }) => (color ? `${theme.palette.primary.contrastText}` : '#212121')};
    background: ${({ color }: ITableRowProps) => (color ? handleNodeColor(color) : '#E0E0E0')};

    &:first-of-type {
      border-top-left-radius: ${({ theme }) => theme.shape.borderRadius}px;
      border-bottom-left-radius: ${({ theme }) => theme.shape.borderRadius}px;
    }

    &:last-of-type {
      border-top-right-radius: ${({ theme }) => theme.shape.borderRadius}px;
      border-bottom-right-radius: ${({ theme }) => theme.shape.borderRadius}px;
    }
  }
  &:hover {
    opacity: 0.95;
  }
`;

export const BodyCell = styled(TableCell)`
  &&& {
    font-size: 13px;
    padding: ${({ theme }) => theme.spacing(1, 0.5)};

    &:nth-of-type(2) {
      text-align: center;
    }
  }

  &:first-of-type {
    white-space: nowrap;
  }
`;

export const Wrapper = styled(Box)`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing(1.5)};
  max-width: fit-content;
`;

export const Button = styled(MUIButton)`
  &&& {
    padding: ${({ theme }) => theme.spacing(0.2)};
    font-size: 12px;
  }
`;

Button.defaultProps = {
  size: 'small',
  variant: 'outlined',
};

export const EmptyInfo = styled(Box)`
  padding: ${({ theme }) => theme.spacing(12)};
  text-align: center;
`;

export const NumerableCell = styled(TableCell)`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  padding: ${({ theme }) => `${theme.spacing(0, 2)}`};
`;
